import { Controller } from 'react-hook-form';
import { Button, DragAndDrop } from '@/components/common';
import { useSubmitVerificationDocument } from '@/hooks';
import { DocumentType } from '@/api/common.types';
import styles from './Steps.module.css';

interface UploadLogoProps {
  setStep: (step: number) => void;
}

export const UploadLogo = ({ setStep }: UploadLogoProps) => {
  const { control, handleSubmit, isDirty, isValid, isSubmitting, onSubmit } = useSubmitVerificationDocument(
    DocumentType.COMPANY_LOGO,
    () => setStep(4),
  );

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <h3 className={styles.title}>{'Please upload one high resolution\nlogo with a transparent\nbackground. *'}</h3>
      <Controller
        name="document"
        control={control}
        render={({ field: { ref, ...rest } }) => <DragAndDrop {...rest} className={styles.input} />}
      />
      <div className={styles.buttons}>
        <Button fluid icon="chevronLeft" onPress={() => setStep(6)} variants="secondary" className={styles.button}>
          Move back
        </Button>
        <Button
          fluid
          icon="chevronRight"
          iconPosition="right"
          type="submit"
          className={styles.button}
          loading={isSubmitting}
          isDisabled={!isDirty || !isValid}
        >
          Next Step
        </Button>
      </div>
    </form>
  );
};
